import { AsyncPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RadiosInput } from '../../../models/inputs/radios-input';
import { BaseInputComponent } from '../base-input/base-input.component';

@Component({
    selector: 'lib-radios-input',
    standalone: true,
    imports: [RadioButtonModule, ButtonModule, FormsModule, ReactiveFormsModule, AsyncPipe],
    template: `
        <div class="d-inline-flex">
            @for (option of control.options | async; track option; let idx=$index) {
            <p-radioButton
                inputId="{{ 'input-' + name + '-' + idx }}"
                class="align-center"
                [class]="control.inputClass.join(' ')"
                [formControl]="control"
                [value]="option.value"
                [class.inline]="control.inline"
            ></p-radioButton>
            <label for="{{ 'input-' + name + '-' + idx }}" class="ml-2">{{ option.label }}</label>

            } @if (control.clearable) {
            <p-button
                type="button"
                class="p-button-text float-right ps-2"
                label="reset"
                size="small"
                (click)="control.reset()"
            ></p-button>
            }
        </div>
    `
})
export class RadiosInputComponent extends BaseInputComponent {
    @Input() name!: string;
    @Input() override control!: RadiosInput;
}
